/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 17:13 23.04.2023
 * @ Description: Class utiliser pour géré la game
 */
import GamePageManager from "../utils/GamePageManager";
import dataOffLine from  '../ressources/data/sentence.json';
import api from "../utils/api";


export default class GameAdmin{
    static instance=null;        // cette class est un singloton car elle dois être accésible depuis nimport quel page
    constructor(){
        GameAdmin.instance=this;
        this.timer=0;
        this.score=0;
        this.sentences=[];
        this.level=0;
        this.maxLevel=5;        // nombre max de level (level = une pharse)
        this.top10=[];          // actual score top 10
        this.maxTime=60;
        this.perfectBonnus=50;  
        this.indexUs=[];
    }
    
    /**
     * add sentences
     * @param {array} addSenetences 
     */
    addSentences(addSenetences){
        if(this.sentences.length>this.level)return;
        this.sentences.push(...addSenetences);
    }


    /**
     * Detruit l'instanc de GameAdmin
     */
    static dellInstance(){
        GameAdmin.instance=null;
    }

    getActualSentence(){
        return this.sentences[this.level]; 
    }

    /**
     * Ajoutes des point au score 
     * @param {int} point point ajouter
     * @returns actual score
     */
    addPoint(point){
        this.score+=point;
        this.score=(this.score<0)?0:this.score;
        return this.score;
    }


    /**
     * Vas au niveau suivant
     */
    nextLevel(){
        this.level++;
        // game level transi
        if(dataOffLine.length==this.sentences.length-1){
            GamePageManager.changePage("GameFinishScreen");
            return; 
        }
        GamePageManager.changePage("GameLevelTransiton");
    }

    getStats(){
        return {score : this.score, time : this.timer};
    }

    /**
     * Check si le score et le temp sont dans le top 10 ou pas
     * @returns {bool}
     */
    checkIfTop10(){

        if(!api.isOnline)return false;

        if(this.top10.length<10)return true;
        let lastPlace=this.top10[this.top10.length-1];

        if(lastPlace.recScore<this.score || (lastPlace.recScore==this.score && lastPlace.recTime>this.timer))return true;

        return false;
    }
}

